'use client';

import { FC, MouseEventHandler, useCallback, useState } from 'react';
import {
  TextButton,
  TextButtonProps,
} from '@tuic/web-compositions/core/TextButton';
import { useClientTranslation } from '@lib/i18n/client';
import { TFunction } from '@tuic/i18n';
import { PhaserClientData } from '../types';

type Props = {
  data?: PhaserClientData;
};

export const CopyBookingButton: FC<Props> = ({ data }) => {
  let { t } = useClientTranslation();
  let [copied, setCopied] = useState<boolean>();

  let handleBookingCopy: MouseEventHandler = useCallback(
    async ev => {
      ev.preventDefault();

      try {
        await navigator.clipboard.writeText(
          data?.serializedPhasedBooking ?? '',
        );
        setCopied(true);
      } catch (e) {
        setCopied(false);
      } finally {
        setTimeout(() => setCopied(undefined), 3000);
      }
    },
    [data?.serializedPhasedBooking],
  );

  return (
    <TextButton
      onClick={handleBookingCopy}
      iconSize="xs"
      {...getCopyButtonProps(t, copied)}
    />
  );
};

const getCopyButtonProps = (
  t: TFunction,
  copied: boolean | undefined,
): TextButtonProps => {
  if (typeof copied === 'undefined') {
    return {
      iconLeft: 'receipt',
      children: t('Buchung in Zwischenablage kopieren'),
    };
  }

  if (copied) {
    return {
      iconLeft: 'check',
      children: t('Erfolgreich kopiert'),
    };
  }

  return {
    iconLeft: 'cancel',
    children: t('Kopieren gescheitert'),
  };
};
